import {
  CartLinePrice,
  CartLineQuantity,
  CartLineQuantityAdjustButton,
  Image,
  Link,
  useCart,
  useCartLine,
} from '@shopify/hydrogen'
import styles from '../../assets/scss/components/cart/mini-cart.module.scss'
import { CartLineMetafields, ProductMetafields } from '../../lib/types'
import { useI18n } from '../i18n.client'
import { useTracking } from '../../lib/hooks/tracking.client'

export const MiniCartLineItem: React.FC = () => {
  const [i18n] = useI18n()
  const { linesRemove } = useCart()
  const cartLine = useCartLine() as CartLineMetafields
  const {
    id,
    merchandise: { product, selectedOptions },
  } = cartLine
  const { trackEvent } = useTracking()

  const handleRemove = () => {
    trackEvent('remove_from_cart', {
      product: product.title,
    })
    linesRemove([id])
  }

  return (
    <div className={styles.lineItem}>
      <Link to={`/products/${product.handle}`}>
        <ProductImage product={product} />
      </Link>
      <div className={styles.productInfo}>
        <Link className={styles.productLink} to={`/products/${product.handle}`}>
          {product.title}
          {selectedOptions.map(
            ({ name, value }) =>
              (name === 'Length' || name === 'Longueur') && (
                <div className={styles.productVariants} key={name}>
                  {name}: {value}
                </div>
              ),
          )}
        </Link>
        <div className={styles.priceContainer}>
          <CartLinePrice />
        </div>
      </div>
      <div>
        <div className={styles.quantityContainer}>
          <CartLineQuantityAdjustButton adjust="decrease" as="div" className={styles.quantityButton}>
            −
          </CartLineQuantityAdjustButton>
          <CartLineQuantity className={styles.quantity} />
          <CartLineQuantityAdjustButton adjust="increase" as="div" className={styles.quantityButton}>
            +
          </CartLineQuantityAdjustButton>
        </div>
        <div className={styles.remove} onClick={handleRemove}>
          {i18n.translate('remove')}
        </div>
      </div>
    </div>
  )
}

const ProductImage: React.FC<{ product: ProductMetafields }> = ({ product }) => {
  if (product.thumbnailImage?.reference.image) {
    return <Image className={styles.productImage} data={product.thumbnailImage?.reference.image} />
  }

  return <Image alt="" className={styles.productImage} height="413" src="https://dummyimage.com/335x413" width="335" />
}
